import React, { useEffect, useState } from "react";
import { Dimensions, Image, StyleSheet, View } from "react-native";
import MaterialTabs from "react-native-material-tabs";
import { RFValue } from "react-native-responsive-fontsize";
import PDFReader from "rn-pdf-reader-js";
import CustomHeader from "../../components/CustomHeader";
import CloseIcon from "../../components/icons/CloseIcon";
import CachedImage from "react-native-expo-cached-image";
import * as FileSystem from "expo-file-system";
import { Button } from "react-native-elements";
import flash from "../../functions/flash";
import * as Permissions from "expo-permissions";
import * as MediaLibrary from "expo-media-library";
import { Entypo } from "@expo/vector-icons";
import saveFileAsync from "../../functions/saveFileAsync";
import DownloadButton from "../../components/DownloadButton";
import useEffectAsync from "../../functions/useEffectAsync";
import firebase from "firebase";
import PrintButton from "../../components/PrintButton";
import { Platform } from "react-native";
import { WebView } from "react-native-webview";

const { height, width } = Dimensions.get("window");

const ViewNotarizeDocuments = ({ route }) => {
  const { item } = route?.params || {};
  const { hasAlreadyLicense, currentReq, documents, firstName, lastName } =
    item || {};
  const { mobile, pro, image, sic } = documents || {};
  const [tabs, setTabs] = useState(
    [
      "Headshot Photo",
      "Professional License",
      hasAlreadyLicense ? null : "State Identification Card",
    ].filter((o) => o)
  );
  const [selectedTab, setSelectedTab] = useState(0);
  const [isMobilePDF, setMobilePDF] = useState(false);

  useEffect(() => {
    if (hasAlreadyLicense || currentReq === "ML DOCUMENT SUBMITTED")
      setTabs([...tabs, "Mobile License"]);
  }, [item]);

  useEffectAsync(async () => {
    if (mobile) {
      let data = await firebase.storage().refFromURL(mobile).getMetadata();
      const { contentType } = data || {};
      if (contentType === "application/pdf") setMobilePDF(true);
    }
  }, [mobile]);

  const name = firstName + "-" + lastName;
  return (
    <View style={styles.container}>
      <CustomHeader title="View Documents" leftIcon={<CloseIcon />} />
      <MaterialTabs
        items={tabs}
        allowFontScaling={true}
        selectedIndex={selectedTab}
        onChange={setSelectedTab}
        barColor="#181d21"
        indicatorColor="#EDD08B"
        activeTextColor="white"
        textStyle={styles.textStyle}
      />

      {selectedTab === 0 ? (
        <>
          {Platform.OS === "web" ? null : (
            <DownloadButton name={name} document={image} fileName="headshot" />
          )}
          <Image source={{ uri: image }} style={styles.image} />
        </>
      ) : selectedTab === 1 ? (
        <>
          {Platform.OS === "web" ? null : (
            <DownloadButton name={name} document={pro} fileName="pro-license" />
          )}
          <Image source={{ uri: pro }} style={styles.image} />
        </>
      ) : selectedTab === 2 && !hasAlreadyLicense ? (
        <>
          {Platform.OS === "web" ? null : (
            <DownloadButton name={name} document={sic} fileName="pro-license" />
          )}
          <Image source={{ uri: sic }} style={styles.image} />
        </>
      ) : isMobilePDF ? (
        <>
          {Platform.OS === "web" ? null : <PrintButton uri={mobile} />}
          <WebView source={{ uri: mobile }} />
        </>
      ) : (
        <>
          {Platform.OS === "web" ? null : (
            <DownloadButton
              name={name}
              document={mobile}
              fileName="mobile-license"
            />
          )}
          <Image source={{ uri: mobile }} style={styles.image} />
        </>
      )}
      {/* {ext === "pdf" ? <PDFReader source={{ uri: url }} /> : null} */}
    </View>
  );
};

export default ViewNotarizeDocuments;

const styles = StyleSheet.create({
  buttonTitle: { fontSize: RFValue(9), fontFamily: "avenir" },
  buttonStyle: {
    alignSelf: "center",
    marginVertical: 10,
    padding: 10,
    borderRadius: 10,
    backgroundColor: "#2E3339",
  },
  image: {
    width: width,
    height: height,
    alignSelf: "center",
    resizeMode: "contain",
  },
  container: { flex: 1, backgroundColor: "#fff" },
  textStyle: { fontFamily: "avenir", fontSize: RFValue(10) },
});
